import { combineReducers } from 'redux';
import { labelSideReducer, siteThemeReducer, languageCodeReducer, storageReducer, userPermissionReducer } from './reduxReducer';


const rootReducer = combineReducers({
    sideBar: labelSideReducer,
    siteTheme: siteThemeReducer,
    languageCode: languageCodeReducer,
    userPermission: userPermissionReducer,
    storageSetting: storageReducer
});

export default rootReducer;
